import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  checkbox: {
    justifyContent: "space-between",
    borderBottom: "1px solid #ddd",
    height: 54,
    padding: "0 15px 0 24px"
  }
}));
